import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';
import { supabase } from '../config/supabase';

const Unsubscribe: React.FC = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'ok' | 'error'>('idle');
  const [working, setWorking] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    const value = email.trim().toLowerCase();
    if (!value.includes('@') || working) return;
    setWorking(true);
    const { error } = await supabase.rpc('record_partner_unsubscribe', { p_email: value });
    setStatus(error ? 'error' : 'ok');
    setWorking(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <SEO title="Unsubscribe from ClubIQ partner email" description="Stop ClubIQ partner outreach email." />
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-8">
        <h1 className="text-2xl font-bold text-gray-900 mb-3">Unsubscribe</h1>
        <p className="text-gray-700 mb-6">
          Enter the email that received a ClubIQ partner note. We will not email that address again.
        </p>
        {status === 'ok' ? (
          <p className="text-green-800 font-medium mb-6">You are unsubscribed.</p>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="you@example.com"
              className="w-full border rounded-xl px-4 py-3"
              required
            />
            <button
              type="submit"
              disabled={working}
              className="w-full bg-green-700 text-white rounded-xl py-3 font-semibold disabled:opacity-60"
            >
              {working ? 'Saving…' : 'Unsubscribe'}
            </button>
            {status === 'error' && (
              <p className="text-red-700">Could not save that request. Try again.</p>
            )}
          </form>
        )}
        <Link to="/" className="text-green-700 font-medium inline-block mt-6">Back to ClubIQ</Link>
      </div>
    </div>
  );
};

export default Unsubscribe;
